<template>
  <div>
    <v-toolbar elevation="0">
      <v-toolbar-title class="primary--text"><h2> Truck Bookings </h2></v-toolbar-title>
    </v-toolbar>

    <div class="bookings" v-if="!loading">
      <v-container fluid>
        <v-tabs v-model="tab">
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab>
            <v-badge
            :content="schedulingBookings.length"
            color="primary--text"
            >
              SCHEDULING
            </v-badge>
          </v-tab>
          <v-tab>
            <v-badge
            :content="scheduledBookings.length"
            color="primary--text"
            >
              SCHEDULED
            </v-badge>
          </v-tab>
          <v-tab>
            <v-badge
            :content="disposingBookings.length"
            color="primary--text"
            >
              DISPOSING
            </v-badge>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <BookingsTable v-bind:bookings='schedulingBookings' />
          </v-tab-item>
          <v-tab-item>
            <BookingsTable v-bind:bookings='scheduledBookings' />
          </v-tab-item>
          <v-tab-item>
            <BookingsTable v-bind:bookings='disposingBookings' />
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </div>
    <div v-if="loading">
      <Loading/>
    </div>
  </div>
</template>

<script>
import BookingsTable from '@/components/bookings/admin/BookingsTable';
import Loading from '@/components/Loading';

export default {
  name: 'TruckBookings',
  components: {
    Loading,
    BookingsTable
  },
  data() {
    return {
      tab: ''
    }
  },
  methods: {

  },
  computed: {
    loading() {
      return this.$store.getters['admin/getLoading'];
    },
    bookingError() {
      return this.$store.getters['admin/getBookingError'];
    },
    schedulingBookings() {
      return this.$store.getters['admin/getTruckBookingsByStatus']('SCHEDULING')
    },
    scheduledBookings() {
      return this.$store.getters['admin/getTruckBookingsByStatus']('SCHEDULED')
    },
    disposingBookings() {
      return this.$store.getters['admin/getTruckBookingsByStatus']('DISPOSING')
    }
  },
  watch: {
    bookingError(error) {
      if (error) {
        alert(error);
      }
    }
  },
  mounted() {
    if(this.$store.state.admin.bookings.length === 0){
      this.$store.dispatch('admin/fetchBookings');
    }
  }
}
</script>

<style scoped>

</style>
